export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-rss-37790458cdc26a41361107ed6f0026e4.svg";